import { JobQueue } from 'components/JobQueue';
import React from 'react';

const JobQueuePage: React.FC = () => {
  return (
    <div
      className="inter-font-family"
      style={{
        backgroundColor: '#ffffff',
        // minHeight: '100vh',
        // padding: '24px',
      }}>
      <JobQueue />
    </div>
  );
};

export default JobQueuePage;
